<template>
  <header class="header" :class="{'scroll': isScrolling}">
      <div class="container">
        <div class="header__right">
            <h3>Prodám <br> Restituce.</h3>
        </div>

        <div class="header__left">
          <div class="actions">
            <div class="header__contact">
                <!-- icon - materioal - phone -->
                <i class="material-icons">phone</i>
                <span>(+420)</span>
                602 879 396
            </div>
          </div>
        </div>
      </div>

  </header>
</template>

<script>
export default {
  name: "header-bar",
  data() {
    return {
      name: 'Filip',
      isScrolling: false
    }
  },
  methods: {
    setScroll(val) {
      this.isScrolling = val
    }
  },
  mounted() {
    let self = this

    function stick() {
      const windowTop = window.pageYOffset
      if( windowTop > 1 ) {
        self.setScroll(true)
      } else {
        self.setScroll(false)
      }
    }
    stick()
    window.addEventListener('scroll', stick);
  },
};
</script>

<style lang="stylus">

@import '../style/config'

.header
  position: fixed
  top: 0
  left: 0
  height: 8rem
  width: 100%
  padding 0 2em
  box-sizing border-box
  z-index: 10
  font-weight: bold
  border-top: solid 6px $blue-dodge
  display: flex
  align-items: center
  transition: all 250ms

  &.scroll
    background-color: white
    height 5rem
    box-shadow: 0 2px 2px alpha(#000, .05)

  .container
    width: 100%
    flex-grow: 1
    display: flex
    margin: 0 auto
    padding 0
    justify-content: space-between
    align-items: center
    box-sizing: border-box
    // background: blue


.header__contact i
  color: #1b85e8


.header__contact span
  color: #d1d1d1
  font-weight: normal
</style>





// WEBPACK FOOTER //
// src/components/HeaderBar.vue